import { DocumentTypeEnum } from 'api-hooks/order/travel-document';
import { DocumentSaleGuestDetailStatusEnum } from 'api-hooks/sale/travel-document';
import { UploadFileTypeEnum } from 'api-hooks/upload/upload.model';
import { EnumList } from 'common/constants/enum';
import { Input } from 'components/elements';
import EnumSelectInput from 'legacy-modules/master/select-input/enum';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  documentIndex: number;
  parentName: string;
  type: 'visa' | 'insurance';
  documentStatus: DocumentSaleGuestDetailStatusEnum | null;
}

export default function VisaInsuranceSection(props: Props) {
  const { t } = useTranslation();
  const { documentIndex, parentName, type, documentStatus } = props;

  const text = React.useMemo(() => {
    if (type === DocumentTypeEnum.visa) {
      return {
        number: t('common:no_visa'),
        issuedAt: t('common:visa_valid'),
        expiriedAt: t('common:visa_expiry'),
      };
    }
    return {
      number: t('common:no_polis'),
      issuedAt: t('common:issue_at'),
      expiriedAt: t('common:expiry_at'),
    };
  }, [t, type]);

  return (
    <>
      <CardSection style={{ paddingBottom: 0 }}>
        <FullContainer>
          <SectionContainer>
            <HalfContainer>
              <EnumSelectInput
                enumType={EnumList.DocumentType}
                name={`documentSales.${documentIndex}.documentType`}
                label={t('document:document_type')}
                placeholder={t('document:document_type')}
                disabled
              />
            </HalfContainer>
            <HalfContainer>
              <EnumSelectInput
                enumType={EnumList.DocumentSaleGuestDetailStatus}
                name={`${parentName}.documentStatus`}
                label={t('document:document_status')}
                placeholder={t('document:document_status')}
                clearable={false}
              />
            </HalfContainer>
          </SectionContainer>
          {documentStatus !== DocumentSaleGuestDetailStatusEnum.Rejected && (
            <>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.type`}
                    label={t('common:type')}
                    placeholder={t('common:type')}
                    disabled
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.number`}
                    label={text.number}
                    placeholder={text.number}
                  />
                </HalfContainer>
              </SectionContainer>
              <SectionContainer>
                <HalfContainer>
                  <SectionContainer>
                    <HalfContainer>
                      <Input
                        type="date-time"
                        name={`${parentName}.issuedAt`}
                        label={text.issuedAt}
                        placeholder={text.issuedAt}
                      />
                    </HalfContainer>
                    <HalfContainer>
                      <Input
                        type="date-time"
                        name={`${parentName}.expiredAt`}
                        label={text.expiriedAt}
                        placeholder={text.expiriedAt}
                      />
                    </HalfContainer>
                  </SectionContainer>
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="files"
                    label={t('common:upload_document')}
                    valueKey="image"
                    previewKey="url"
                    name={`${parentName}.files`}
                    fileType={
                      UploadFileTypeEnum[
                        type === 'insurance'
                          ? 'DocumentSaleInsuranceGuestDetail'
                          : 'DocumentSaleVisaGuestDetail'
                      ]
                    }
                    required
                  />
                </HalfContainer>
              </SectionContainer>
            </>
          )}
        </FullContainer>
      </CardSection>
      <SeparatorVertical $margin={36} />
    </>
  );
}
